import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import { cdnURL } from 'components/utils/cdn';
import Picture from 'components/ui/picture';
import { PlusSignsPattern } from 'components/ui/icons';
import Button from 'components/ui/button';

import { useIsMobile } from 'hooks/app';

import './styles.scss';

const GroupCardsPromo = ({ className }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const navigate = useNavigate();
  const isMobile = useIsMobile(['XXXS', 'XXS', 'XS', 'SM']);


  const onImageLoaded = () => {
    setTimeout(() => {
      setImageLoaded(true);
    }, 100);
  }

  const onClick = () => {
    navigate('/cards/birthday-wishes/birthday-group-cards');
  }


  let cardFrameComponent = (
    <Picture
      src={cdnURL('img/rebuild/promote/group-card/monitor-frame.png')}
      has2x
      hasWebp
      alt="Group Card Frame"
      onLoaded={onImageLoaded}
      width={739}
      height={493}
    />
  );
  let videoComponent = (
    <video
      src={cdnURL('video/group-card-sample-desktop-2.mp4')}
      width={706}
      height={406}
      loop
      muted
      autoPlay
      playsInline
      className="group-cards-promo-iframe"
    />
  );
  if (isMobile) {
    cardFrameComponent = (
      <Picture
        src={cdnURL('img/rebuild/promote/group-card/mobile-frame.png')}
        has2x
        hasWebp
        alt="Group Card Frame"
        onLoaded={onImageLoaded}
        width={364}
        height={444}
      />
    );
    videoComponent = (
      <video
        src={cdnURL('video/group-card-sample-mobile-2.mp4')}
        width={234}
        height={396}
        loop
        muted
        autoPlay
        playsInline
        className="group-cards-promo-iframe"
      />
    );
  }

  return (
    <div className={`group-cards-promo-container ${className}`}>
      <div className="background-pattern">
        <PlusSignsPattern color="#ffffff"/>
      </div>
      <div className="group-cards-promo-image-section">
        <div className={`image-container ${imageLoaded ? 'animate' : ''}`}>
          {cardFrameComponent}
          {videoComponent}
        </div>
        <Button onClick={onClick} color="white">Start a Group Card</Button>
      </div>
      <div className="group-cards-promo-title-section">
        <p className="group-cards-promo-subtitle">GROUP CARDS</p>
        <h2 className="group-cards-promo-title">Transform any card into a shared experience!</h2>
        <Button onClick={onClick} color="white">Start a Group Card</Button>
      </div>
    </div>
  );
}


GroupCardsPromo.propTypes = {
  className: PropTypes.string,
};

GroupCardsPromo.defaultProps = {
  className: ''
};

export default GroupCardsPromo;
